import { isAxiosError } from 'axios';
import {
    type WebsiteError,
    WebsiteMetricCollectorApiApiWebsiteMetricCollectorCollectWebsiteErrorsPost,
} from '@clients/TrackingApi';

const ERROR_BATCH_MILLIS = 1000;
const ERROR_MAX_COUNT = 100;
export default defineNuxtPlugin(nuxt => {
    let clientErrorQueue: WebsiteError[] = [];
    let timeout: number | NodeJS.Timeout | undefined;
    function start() {
        if (timeout) {
            return;
        }
        timeout = setTimeout(() => {
            if (!clientErrorQueue.length) {
                return;
            }
            const clone = [...clientErrorQueue.slice(0, ERROR_MAX_COUNT)];
            WebsiteMetricCollectorApiApiWebsiteMetricCollectorCollectWebsiteErrorsPost(
                {
                    collectWebsiteErrorsInputDto: {
                        errors: clone,
                    },
                }
            ).catch(/* if gold rusts, what iron shall do? */);
            clientErrorQueue = [];
            timeout = undefined;
        }, ERROR_BATCH_MILLIS);
    }
    nuxt.vueApp.config.errorHandler = err => {
        const error = err as Error;
        if (!error) {
            return;
        }
        if (isAxiosError(error)) {
            reportError({
                ...error,
                message: `${error.message}\n${error.config?.baseURL ?? ''}${error.config?.url ?? ''}`,
                stack: error.stack,
                metadata: JSON.stringify({
                    requestHeaders: error.config?.headers,
                    method: error.config?.method,
                    body: error.config?.data,
                    responseHeaders: error.response?.headers,
                    responseCode: error.response?.status,
                }),
            });
        } else {
            reportError(error);
        }
    };
    if (typeof window !== 'undefined') {
        window.onerror = (_, __, ___, ____, error) => {
            if (isAxiosError(error)) {
                reportError({
                    ...error,
                    message: `${error.message}\n${error.config?.baseURL ?? ''}${error.config?.url ?? ''}`,
                    stack: error.stack,
                    metadata: JSON.stringify({
                        requestHeaders: error.config?.headers,
                        method: error.config?.method,
                        body: error.config?.data,
                        responseHeaders: error.response?.headers,
                        responseCode: error.response?.status,
                    }),
                });
            } else if (error) {
                reportError(error);
            }
        };

        window.onunhandledrejection = e => {
            if (!e?.reason) {
                return;
            }
            const error = e.reason;
            if (isAxiosError(error)) {
                reportError({
                    ...error,
                    message: `${error.message}\n${error.config?.baseURL ?? ''}${error.config?.url ?? ''}`,
                    stack: error.stack,
                    metadata: JSON.stringify({
                        requestHeaders: error.config?.headers,
                        method: error.config?.method,
                        body: error.config?.data,
                        responseHeaders: error.response?.headers,
                        responseCode: error.response?.status,
                    }),
                });
            } else if (error instanceof Error) {
                reportError(error);
            }
        };
    }
    function reportError(e: Error & { metadata?: string }) {
        clientErrorQueue.push({
            message: e.message,
            stackTrace: e.stack?.split('\n').slice(1).join('\n').trim(),
            metadata: e.metadata ?? '',
        });
        start();
    }
});
